<template>
  <v-container id="mobile-app-view" class="mx-auto text-center d-flex flex-column justify-center align-center" fluid
    tag="section">

    <v-spacer></v-spacer>
    <v-img :src="'/img/icon-round.png'" max-height="100" contain></v-img>
    <h1 class="mb-4">Pobierz naszą aplikację mobilną!</h1>
    <p class="mb-6">Korzystaj z pełni możliwości naszej aplikacji na swoim urządzeniu mobilnym.</p>

    <v-row justify="center">
      <v-col cols="12" xs="12" sm="6" class="justify-center mb-2">
        <a href="https://play.google.com/store/apps/details?id=pl.monpatrol.app" target="_blank">
          <v-img :src="'/img/google-play_pl.png'" max-height="80" contain></v-img>
        </a>
      </v-col>
      <v-col cols="12" xs="12" sm="6" class="justify-center mb-2">
        <a href="https://apps.apple.com/pl/app/monpatrol/id6569242686" target="_blank">
          <v-img :src="'/img/apple-store_pl.png'" max-height="80" contain></v-img>
        </a>
      </v-col>
    </v-row>
    <v-spacer></v-spacer>
  </v-container>
</template>

<script>
export default {
  name: 'MobileApp',
  data: () => ({}),
  mounted() {
    // Attempt to open the app using the custom URL scheme
    window.location.href = 'monpatrol://open-app';
  },
};
</script>

<style lang="sass">
#mobile-app-view
  h1
    font-size: 2rem
    font-weight: bold

  p
    font-size: 1.2rem
</style>
